import { Link } from "react-router-dom";
import { AREAS } from "@/lib/business";
import { MapPin, ArrowRight } from "lucide-react";

export default function AreasIndex() {
  const hampshire = AREAS.filter(a => /Hampshire/i.test(a.region));
  const surrey = AREAS.filter(a => /Surrey/i.test(a.region));

  return (
    <div>
      <section className="hero-wash">
        <div className="container-x py-12">
          <p className="text-sm font-semibold text-[color:var(--icrack-magenta-deep)] uppercase tracking-wider">Local Coverage</p>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold">Areas we cover across Hampshire &amp; Surrey</h1>
          <p className="mt-3 max-w-2xl text-slate-600">iCrack Solutions serves customers in-store at 94 Market Street, Eastleigh, plus a mobile call-out service across a wide area — with no call-out charge. Choose your town below for local details and booking.</p>
        </div>
      </section>

      <section className="section-pad" data-testid="areas-index">
        <div className="container-x space-y-10">
          {[{ title: "Hampshire", areas: hampshire }, { title: "Surrey", areas: surrey }].map(group => (
            <div key={group.title}>
              <h2 className="font-display text-2xl sm:text-3xl font-bold">{group.title}</h2>
              <div className="mt-4 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {group.areas.map(a => (
                  <Link
                    key={a.slug}
                    to={`/areas/${a.slug}`}
                    className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 hover:border-pink-200 hover:shadow-md transition-shadow"
                    data-testid={`area-index-${a.slug}`}
                  >
                    <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full" style={{ background: "var(--icrack-magenta-soft)", opacity: 0.65 }} aria-hidden />
                    <div className="relative">
                      <div className="flex items-center gap-2">
                        <MapPin className="h-4 w-4" style={{ color: "var(--icrack-magenta)" }} />
                        <span className="font-display text-lg font-bold text-slate-900">{a.name}</span>
                      </div>
                      <p className="mt-1 text-xs text-slate-500">{a.region} • {a.postcodePrefix}</p>
                      <p className="mt-3 text-sm text-slate-600 line-clamp-3">{a.blurb}</p>
                      <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold" style={{ color: "var(--icrack-magenta-deep)" }}>
                        View {a.name} <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
